import '../../styles/panels.css'

const ZONE_TYPES = [
  { label: 'Zone standard', color: '#4ade80' },
  { label: 'Zone securisee', color: '#f59e0b' },
  { label: 'Zone restreinte', color: '#ef4444' },
]

const WALL_TYPES = [
  { label: 'Mur manuel', color: '#cccccc' },
  { label: 'Mur IFC', color: '#8888aa' },
  { label: 'Mur porteur', color: '#ff8888' },
]

const STATUS_TYPES = [
  { label: 'Present', color: '#4ade80' },
  { label: 'Absent', color: '#9ca3af' },
  { label: 'Alerte', color: '#ef4444' },
]

export default function LegendPanel() {
  return (
    <div className="legend-panel">
      <div className="panel-section__title">Legende</div>

      <div className="legend-panel__group">
        <div className="legend-panel__group-title">Statuts occupants</div>
        {STATUS_TYPES.map((item) => (
          <div key={item.label} className="legend-panel__item">
            <span className="legend-panel__dot" style={{ background: item.color }} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>

      <div className="legend-panel__group">
        <div className="legend-panel__group-title">Types de zones</div>
        {ZONE_TYPES.map((item) => (
          <div key={item.label} className="legend-panel__item">
            <span className="legend-panel__swatch" style={{ background: item.color }} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>

      <div className="legend-panel__group">
        <div className="legend-panel__group-title">Types de murs</div>
        {WALL_TYPES.map((item) => (
          <div key={item.label} className="legend-panel__item">
            <span className="legend-panel__swatch" style={{ background: item.color }} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
